@import (reference) '../../../../constants/spacing.module.less';

.primary-shipment-sections {
  grid-area: primary-shipment-sections;
  gap: @space-16;
  min-width: 0;
}

.fulfillment-planner-sections {
  grid-area: fulfillment-planner-sections;
  gap: @space-16;
}

.secondary-shipment-sections {
  grid-area: secondary-shipment-sections;
  gap: @space-16;
  padding-bottom: @space-16;
}

.column1 {
  grid-area: column1;
  gap: @space-16;
}

.column2 {
  grid-area: column2;
  gap: @space-16;
}

.column3 {
  grid-area: column3;
  gap: @space-16;
}

.rate-card {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;

  grid-area: rate-card;
  position: sticky;
  bottom: 0;
  margin-left: -@space-16;
  margin-right: -@space-16;
}
